import { BuoyDrawingPropertyDto, MooringServiceCorridorDirection } from 'models/mooring';
import { generateVariableGrid } from '../helpers';
import { Coordinate } from 'ol/coordinate';
import { drawPoint } from '../drawing/point';
import VectorSource from 'ol/source/Vector';
import { fromLonLat } from 'ol/proj';
import { ensureNumberOrDefault } from 'lib/helpers';

export type BuoyGrid = {
  Id: number;
  Row: number;
  Column: number;
  Diameter: number;
  Center: Coordinate;
};

const DIAMETER = 40;

/**
 * Calculate all buoy coordinates for a grid setup
 */
export function createBuoyGrid(
  cornerBuoys: Coordinate[],
  buoysX: number,
  buoysY: number,
  buoys: BuoyDrawingPropertyDto[],
  gridLineLength: number,
  serviceCorridor?: {
    Direction: MooringServiceCorridorDirection;
    Placement: number;
    Width: number;
  },
  vs?: VectorSource
) {
  if (cornerBuoys.length !== 4) {
    throw new Error('Exactly 4 corner buoys required');
  }

  const [topLeft, topRight, bottomRight, bottomLeft] = cornerBuoys;

  const buoyGrid: BuoyGrid[][] = [];

  // Build distance arrays with service corridor spacing
  // Note: for N buoys, we need N-1 spacing values (the gaps between them)
  const by = Array(buoysY)
    .fill(0)
    .map((_, index) => {
      if (serviceCorridor?.Direction === MooringServiceCorridorDirection.Horizontal && index === serviceCorridor.Placement - 1) {
        return ensureNumberOrDefault(serviceCorridor.Width, gridLineLength);
      }
      return gridLineLength;
    });

  const bx = Array(buoysX)
    .fill(0)
    .map((_, index) => {
      if (serviceCorridor?.Direction === MooringServiceCorridorDirection.Vertical && index === serviceCorridor.Placement - 1) {
        return ensureNumberOrDefault(serviceCorridor.Width, gridLineLength);
      }
      return gridLineLength;
    });

  const grid = generateVariableGrid(topLeft, topRight, bottomLeft, bottomRight, bx, by);
  const rows = grid.length;
  const cols = grid[0].length;

  for (let row = 0; row < rows; row++) {
    buoyGrid[row] = [];
    for (let col = 0; col < cols; col++) {
      const center = grid[row][col];

      const buoy = buoys.find((b) => b.Row === row + 1 && b.Column === col + 1);

      if (buoy) {
        const b = {
          Id: buoy.Id,
          Row: buoy.Row,
          Column: buoy.Column,
          Diameter: DIAMETER,
          Center: center,
        };
        buoyGrid[row][col] = b;
      } else {
        console.warn(`No buoy found for Row ${row + 1}, Column ${col + 1}`);
      }
    }
  }

  // if (vs) {
  //   void drawPoint({
  //     id: 'tl',
  //     diameter: DIAMETER,
  //     point: fromLonLat(topLeft),
  //     style: { fillColor: '#220022' },
  //     text: `${topLeft[1].toFixed(4)}, ${topLeft[0].toFixed(4)}`,
  //     vs,
  //   });

  //   void drawPoint({
  //     id: 'tr',
  //     diameter: DIAMETER,
  //     point: fromLonLat(topRight),
  //     style: { fillColor: '#229922' },
  //     text: `${topRight[1].toFixed(4)}, ${topRight[0].toFixed(4)}`,
  //     vs,
  //   });

  //   void drawPoint({
  //     id: 'br',
  //     diameter: DIAMETER,
  //     point: fromLonLat(bottomRight),
  //     style: { fillColor: '#222299' },
  //     text: `${bottomRight[1].toFixed(4)}, ${bottomRight[0].toFixed(4)}`,
  //     vs,
  //   });

  //   void drawPoint({
  //     id: 'bl',
  //     diameter: DIAMETER,
  //     point: fromLonLat(bottomLeft),
  //     style: { fillColor: '#999922' },
  //     text: `${bottomLeft[1].toFixed(4)}, ${bottomLeft[0].toFixed(4)}`,
  //     vs,
  //   });
  // }

  return buoyGrid;
}
